import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { contactConfig } from '../../lib/contact-config';

interface AuthConfig {
  company_logo_url: string | null;
  secondary_logo_url: string | null;
  support_email: string;
}

export default function AuthFooter() {
  const [config, setConfig] = useState<AuthConfig | null>(null);
  const [copyFeedback, setCopyFeedback] = useState(false);

  const supportEmail = config?.support_email || contactConfig.assistance.email;

  useEffect(() => {
    axios
      .get('/api/auth/config')
      .then((res) => setConfig(res.data))
      .catch(() => {});
  }, []);

  const handleCopyEmail = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(supportEmail).then(() => {
      setCopyFeedback(true);
      setTimeout(() => setCopyFeedback(false), 2000);
    });
  };

  return (
    <div className="tw-mt-6 tw-pt-5 tw-border-t tw-border-gray-200">
      {/* Support */}
      <div className="tw-mb-4 tw-text-center">
        <span className="tw-block tw-text-gray-400 tw-text-xs tw-mb-2 tw-uppercase tw-tracking-wide">
          Hai bisogno di aiuto? Contattaci
        </span>
        <div className="tw-flex tw-items-center tw-justify-center tw-gap-2">
          <a
            href={`mailto:${supportEmail}?subject=Richiesta%20assistenza%20-%20Consultorio%204.0`}
            className="tw-inline-flex tw-items-center tw-gap-1.5 tw-bg-gray-50 tw-py-2 tw-px-3.5 tw-rounded-md tw-no-underline tw-border tw-border-gray-200 tw-transition-all tw-duration-200 hover:tw-bg-gray-100 hover:tw-border-blue-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#3b82f6"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="tw-flex-shrink-0"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            <span className="tw-text-blue-500 tw-text-[13px] tw-font-semibold">{supportEmail}</span>
          </a>
          <button
            type="button"
            className="tw-bg-white tw-border tw-border-gray-200 tw-cursor-pointer tw-py-2 tw-px-2.5 tw-text-gray-400 tw-inline-flex tw-items-center tw-gap-1 tw-rounded-md tw-transition-all tw-duration-200 tw-text-[11px] tw-font-medium hover:tw-bg-blue-500 hover:tw-border-blue-500 hover:tw-text-white"
            onClick={handleCopyEmail}
            title="Clicca per copiare"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
            </svg>
            {copyFeedback ? 'Copiato!' : 'Copia'}
          </button>
        </div>
      </div>

      {/* Logos */}
      {(config?.company_logo_url || config?.secondary_logo_url) && (
        <div className="tw-flex tw-justify-between tw-items-center tw-mt-4">
          {config?.company_logo_url && (
            <div className="tw-w-[48%]">
              <img src={config.company_logo_url} alt="Logo" className="tw-max-w-full tw-h-auto" />
            </div>
          )}
          {config?.secondary_logo_url && (
            <div className="tw-w-[48%]">
              <img src={config.secondary_logo_url} alt="Logo" className="tw-max-w-full tw-h-auto" />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
